import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { Alert, Button } from 'react-bootstrap';
import api from '../helpers/ApiClient';
import qs from 'qs';
import moment from 'moment';
import _ from 'lodash';
import ReactTooltip from 'react-tooltip'
import Loader from '../components/Loader';
import giftTypesSelect from '../data/product_types.json'
import budgetSelect from '../data/budget.json'
import InputRange from 'react-input-range';
import InputRangeCSS from 'react-input-range/lib/css/index.css';
import giftFinderLogo from '../images/gift_finder.png'

const states = ["Johor","Kedah","Kelantan","Melaka","Negeri Sembilan","Pahang","Pulau Pinang","Perak","Perlis","Sabah","Sarawak","Selangor","Terengganu","Kuala Lumpur","Labuan","Putrajaya"]

const cities = [ {name: "Perlis", cities: ['Kangar','Kuala Perlis','Padang Besar','Kaki Bukit','Arau','Simpang Ampat']} ,
                { name: "Kedah", cities: ['Alor Setar','Jitra','Changloon','Bukit Kayu Hitam','Kodiang','Ayer Hitam','Kepala Batas','Kuala Nerang','Pokok Sena','Langgar','Kuala Kedah','Simpang Empat','Pendang','Kota Sarang Semut','Yan','Langkawi','Sungai Petani','Bedong','Sik','Gurun','Jeniang','Merbok','Kota Kuala Muda','Kulim','Baling','Kuala Pegang','Kupang','Kuala Ketil','Padang Serai','Lunas','Karangan','Serdang', 'Bandar Baharu']},
                {name: "Pulau Pinang", cities: ['Pulau Pinang','Balik Pulau','Batu Ferringhi','Tanjong Bungah','Penang Hill','Ayer Itam','Jelutong','Gelugor','USM Pulau Pinang','Bayan Lepas','Batu Maung','Butterworth','Penaga','Tasek Gelugor','Permatang Pauh','Perai','Bukit Mertajam','Sungai Jawi','Nibong Tebal','Kubang Semang']} ,
                {name: "Kelantan", cities: ['Kota Bharu','Bachok','Wakaf Bharu','Tumpat','Melor','Ketereh','Kem Desa Pahlawan','Pulai Chondong','Cherang Ruku','Pasir Puteh','Selising','Pasir Mas','Rantau Panjang','Tanah Merah','Jeli','Kuala Balah','Ayer Lanas','Kuala Krai','Dabong','Gua Musang','Temangan','Machang']},
                {name: "Terengganu", cities: ['Kuala Terengganu','Bukit Payong','Chalok','Sungai Tong','Marang','Kuala Berang','Ajil','Jerteh','Permaisuri','Kampung Raja','Kuala Besut','Dungun','Paka','Bukit Besi','Ketengah Jaya','Al Muktatfi Billah Shah','Cukai','Ayer Puteh','Ceneh','Kijal','Kemasek','Kerteh']},
                {name: "Pahang", cities: ['Kuantan','Bukit Goh','Balok','Sungai Lembing','Gambang','Bandar Pusat Jengka','Maran','Pekan','Chini','Muadzam Shah','Kuala Rompin','Bandar Tun Abdul Razak','Jerantut','Damak','Padang Tengku','Kuala Lipis','Benta','Dong','Raub','Sungai Koyan','Sega','Temerloh','Kuala Krau','Chenor','Triang','Kemayan','Mentakab','Lanchang','Karak','Bentong','Lurah Bilut', 'Tanah Rata','Brinchang','Ringlet', 'Bukit Fraser', 'Genting Highlands']},
                {name: "Perak", cities: ['Ipoh','Batu Gajah','Sungai Siput','Ulu Kinta','Chemor','Tanjong Rambutan','Kampung Kepayang','Pusing','Gopeng','Malim Nawar','Tronoh','Tanjong Tualang','Jeram','Kampar','Sitiawan','Seri Manjong','TLDM Lumut','Lumut','Pangkor','Ayer Tawar','Changkat Keruing','Bota','Bandar Seri Iskandar','Bruas','Parit','Lambor Kanan','Kuala Kangsar','Pengkalan Hulu','Intan','Gerik','Lenggong','Sauk','Enggor','Padang Rengas','Manong','Taiping','Selama','Parit Buntar','Tanjong Piandang','Bagan Serai','Kuala Kurau','Simpang Ampat Semanggol','Batu Kurau','Kamunting','Kuala Sepetang','Simpang','Matang','Trong','Changkat Jering','Pantai Remis','Tapah','Chenderiang','Temoh','Tapah Road','Bidor','Sungkai','Trolak','Slim River','Tanjong Malim','Behrang Stesen','Teluk Intan','Bagan Datoh','Selekoh','Sungai Sumun','Hutan Melintang','Ulu Bernam','Chenderong Balai','Langkap','Chikus','Kampung Gajah']},
                {name: "Putrajaya", cities: ['Putrajaya']},
                {name: "Kuala Lumpur", cities: ['Kuala Lumpur']},
                {name: "Selangor", cities: ['Shah Alam','Klang','Pelabuhan Klang','Kapar','Bandar Puncak Alam','Telok Panglima Garang','Jenjarom','Banting','Tanjong Sepat','Pulau Indah','Pulau Ketam','Pulau Carey','Kajang','Hulu Langat','Cheras','Seri Kembangan','Semenyih','Bandar Baru Bangi','Beranang','Dengkil','Sepang','Sungai Pelek','Kuala Kubu Baru','Kerling','Rasa','Batang Kali','Kuala Selangor','Sungai Ayer Tawar','Sabak Bernam','Sungai Besar','Sekinchan','Tanjong Karang','Batang Berjuntai','Bukit Rotan','Petaling Jaya','Sungai Buloh','Puchong','Subang Jaya','Rawang','Batu Arang','Serendah','Cyberjaya','KLIA','Ampang','Batu Caves']},
                {name: "Negeri Sembilan", cities: ['Seremban','Port Dickson','Si Rusa','Rantau','Linggi','Rembau','Kota','Tanjong Ipoh','Kuala Klawang','Mantin','Bandar Enstek','Nilai','Labu','Kuala Pilah','Bahau','Bandar Seri Jempol','Batu Kikir','Simpang Pertang','Simpang Durian','Tampin','Johol','Gemencheh','Gemas','Pusat Bandar Palong','Rompin']},
                {name: "Melaka", cities: ['Melaka','Ayer Keroh','Durian Tunggal','Kem Trendak','Sungai Udang','Tanjong Kling','Jasin','Asahan','Bemban','Merlimau','Sungai Rambai','Selandar','Alor Gajah','Lubok China','Kuala Sungai Baru','Masjid Tanah']},
                {name: "Johor", cities: ['Nusajaya','Johor Bahru','Kulai','Senai','Bandar Tenggara','Gugusan Taib Andak','Pekan Nenas','Gelang Patah','Pengerang','Pasir Gudang','Masai','Ulu Tiram','Layang-Layang','Kota Tinggi','Ayer Tawar 2','Bandar Penawar','Pontian','Ayer Baloi','Benut','Kukup','Batu Pahat','Rengit','Senggarang','Seri Gading','Seri Medan','Parit Sulong','Semerah','Yong Peng','Muar','Parit Jawa','Bukit Pasir','Sungai Mati','Panchor','Pagoh','Gerisek','Bukit Gambir','Tangkak','Segamat','Batu Anam','Jementah','Labis','Chaah','Kluang','Simpang Rengam','Rengam','Parit Raja','Bekok','Paloh','Kahang','Mersing','Endau']},
                {name: "Labuan", cities: ['Labuan']},
                {name: "Sabah", cities: ['Kota Kinabalu','Beverly','Putatan','Likas','Inanam','Tanjung Aru','Keningau','Kudat','Kota Marudu','Kota Belud','Tuaran','Tamparuli','Ranau','Penampang','Papar','Tambunan','Bongawan','Membakut','Kuala Penyu','Menumbok','Beaufort','Sipitang','Tenom','Nabawan','Sandakan','Beluran','Kota Kinabatangan','Pamol','Tawau','Lahad Datu','Kunak','Semporna']},
                {name: "Sarawak", cities: ['Kuching','Bau','Siburan','Kota Samarahan','Lundu','Asajaya','Kabong','Serian','Simunjan','Sebuyau','Lingga','Pusa','Sri Aman','Roban','Saratok','Debak','Spaoh','Betong','Engkilili','Lubok Antu','Sibu','Sarikei','Belawai','Daro','Matu','Dalat','Balingian','Mukah','Bintangor','Julau','Kanowit','Kapit','Song','Belaga','Bintulu','Sebauh','Tatau','Miri','Baram','Lutong','Bekenu','Niah','Long Lama','Limbang','Nanga Medamit','Sundar','Lawas']},
]

class GiftFinderNew extends Component {

    constructor(props) {
        super(props);

        let submitted, loading, questionSequence, exceptionList
        moment().utcOffset(8)

        this.state = {
            submitted,
            vendors: '',
            giftType: '',
            loading,
            city: '',
            cityList: [],
            postcode: '',
            exceptionList,
            additionParams: '',
            budget: { min: 30, max: 3000 }
        };
    }

    handleBudgetClick = (value) => {

        this.setState({ budget: value, questionSequence: 3 });
        let { person, location, delivery } = this.state;
    }

    handleSearchClick = () => {
        const { state, city, budget, giftType, location } = this.state;
        const budgetStr = `${budget.min}-${budget.max}`
        const cityStr = `${city}`
        const stateStr = `${state}`

        return api('/api/gift_finder', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                budget: decodeURIComponent(budgetStr),
                city: decodeURIComponent(cityStr),
                state: decodeURIComponent(stateStr),
                gifttype: decodeURIComponent(giftType)
            })
        })
    }

    // handlePostcodeChange = (event) => {
    //     let postcode = event.target.value;

    //     this.setState({postcode})

    //     if(postcode && postcode.length === 5){
    //         this.setState({ loading: true, city: '' });
    //         return api(`api/lookup/vendor/${postcode}`, {
    //             method: 'GET',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             }
    //         }).then(result => {

    //             this.setState({ loading: false });

    //             if(result){
    //                 this.setState({ city: result.city, vendors: result.vendors, exceptionList: result.exception_list, additionParams: result.additional_params });
    //             } else {
    //                 this.setState({ city: 'Invalid postcode', vendors: '' });
    //             }
    //         })
    //     }
    // }

    handleBudgetChange = (value) => {
        this.setState({ budget: value })
    }

    handleGiftTypeChange = (event) => {
        let giftType = event.target.value;
        let { exceptionList } = this.state;

        let filtered = _.filter(exceptionList, function(exception){
            if(exception.gifttypes === giftType){
                return true
            }
        })

        if(filtered){
            let { vendors } = this.state
            if(vendors){
                let addition = '';
                _.each(filtered, function(item){
                    addition+= '|' + item.vendor.replace(/&/g, '%26')
                })

                vendors += addition;
                this.setState({vendors})
            }
        }

        this.setState({giftType})
    }

    handleStateChange = (event) => {
        let state = event.target.value;

        let cityList = _.find(cities, (city) => {
            return city.name === state
        })
        this.setState({state, cityList: cityList.cities})
    }

    handleCityChange = (event) => {
        let city = event.target.value;

        this.setState({city})
    }

    handleMinBudgetChange = (event) => {
        let min = event.target.value
        let { budget } = this.state;
        budget.min = min
        this.setState({ budget })
    }

    handleMaxBudgetChange = (event) => {
        let max = event.target.value
        let { budget } = this.state;
        budget.max = max
        this.setState({ budget })
    }

    formatInputRange = (value, type) => {
        if(type === 'min' || type === 'max'){
            return `RM${value}`
        }
    }

    render() {

        const { error } = this.props
        const { city, budget, vendors, giftType, location,delivery, loading, submitted, additionParams, cityList } = this.state;

        const budgetStr = `${budget.min}%2C${budget.max}`
        let style = {
            border:'none',
            overflow:'hidden'
           }

        return (
            <div className="container giftr-finder-container">
                <div className="row">
                    <div className="col-md-1 col-lg-2">
                        <p className="gift-finder-logo-wrapper">
                            <img className="gift-finder-logo" src={giftFinderLogo} alt="gift finder"/>
                            <span className="gift-finder-logo-text">Quick Search</span>
                        </p>
                    </div>
                    <div className="col-md-2 col-lg-2">
                        <div className="form-group">
                            <select className="form-control" name="subject" onChange={this.handleStateChange}>
                                <option disabled selected>Select state</option>
                                {
                                    states.map(item => {
                                        return <option key={item} value={item}>{item}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    <div className="col-md-2 col-lg-2">
                        <div className="form-group">
                            <select className="form-control" name="subject" onChange={this.handleCityChange} disabled={cityList.length === 0}>
                                <option disabled selected>Select city</option>
                                {
                                    cityList.map(item => {
                                        return <option key={item} value={item}>{item}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    <div className="col-md-2 col-lg-2">
                        <div className="form-group">
                            <div className="row">
                                <div className="col-xs-5 col-md-5 budget-min">
                                    <input className="form-control" value={budget.min} placeholder="Min." type="text" onChange={this.handleMinBudgetChange}/>
                                </div>
                                <div className="col-xs-2 col-md-2">
                                    <div className="dash"></div>
                                </div>
                                <div className="col-xs-5 col-md-5 budget-max">
                                    <input className="form-control" value={budget.max} placeholder="Max." type="text" onChange={this.handleMaxBudgetChange}/>
                                </div>
                            </div>
                            <div className="budget-slider">
                                <InputRange
                                    maxValue={3000}
                                    minValue={30}
                                    step={10}
                                    formatLabel={this.formatInputRange}
                                    value={budget}
                                    onChange={this.handleBudgetChange} />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 col-lg-2">
                        <div className="form-group">
                            <select className="form-control" name="subject" onChange={this.handleGiftTypeChange}>
                                <option disabled selected>Select gift type</option>
                                {
                                    giftTypesSelect.map(item => {
                                        return <option key={item.name} value={item.value}>{item.name}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <a target="_blank" href={loading ? '' : `https://giftr.my/pages/search-results-page?${additionParams}&page=1&rb_product_type=${giftType}&rb_price=${budgetStr}&rb_filter_ptag_97d68d9098015602983184c1f01bf156=${city}%7CNationwide&sort_by=total_reviews`} onClick={this.handleSearchClick} className={`${loading?'disabled':''} btn btn-block btn btn-success btn-gift-finder-search`}>Search</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect((state, props) => {

    return {

    };
})(GiftFinderNew);
